export const ADD_APP_SNACK_NOTICE = 'components/ADD_APP_SNACK_NOTICE';
export const REMOVE_APP_SNACK_NOTICE = 'components/REMOVE_APP_SNACK_NOTICE';
export const CLEAR_APP_NOTICES = 'components/CLEAR_APP_NOTICES';

export const ADD_PAGE_SNACK_NOTICE = 'pages/ADD_PAGE_SNACK_NOTICE';
export const REMOVE_PAGE_SNACK_NOTICE = 'pages/REMOVE_PAGE_SNACK_NOTICE';
